import { Component, Input, OnInit } from '@angular/core';
import { Test } from 'src/app/models/test.model';

@Component({
  selector: 'ct-index-report',
  templateUrl: './index-report.component.html',
  styleUrls: ['./index-report.component.scss']
})
export class IndexReportComponent implements OnInit {

  @Input() colors: any;
  @Input() reportType: any;
  @Input() test: Test;
  @Input() isMD: boolean;
  @Input() dinamicPageNumber1: number;
  @Input() dinamicPageNumber2: number;

  constructor() { }

  ngOnInit(): void {
  }

}
